import { getColorRgba } from '../../mission-summary/components/colors';
import { FetchTraitsQuery, MissionTraitAnalysis } from '@edwin-group/cj-graphql';

export const parseMissionTraitAnalysis = (reportData: MissionTraitAnalysis[], traitsData: FetchTraitsQuery) => {
  const traits = traitsData?.traits?.map((trait) => trait?.trait).filter((trait) => trait !== 'RESPECT');
  const radarData = {
    labels: traits,
    datasets:
      reportData?.map((item, index) => {
        const data = traits.map((trait) => {
          return item?.values?.find((item) => item?.trait === trait)?.value || 0;
        });

        const color = getColorRgba(index, 1);
        const colorWithOpacity = getColorRgba(index, 0.3);

        return {
          label: item?.cohortName || '',
          data,
          fill: true,
          pointBackgroundColor: color,
          borderColor: color,
          backgroundColor: colorWithOpacity,
        };
      }) || [],
  };

  return radarData;
};
